(() => {
  if (window.vlsurGlobalCartNotificationLoaded) {
    return;
  }

  window.vlsurGlobalCartNotificationLoaded = true;

  const originalFetch = window.fetch.bind(window);

  let hideTimer;

  const getCartUrl = () => {
    if (
      window.theme &&
      theme.routes_cart_url
    ) {
      return theme.routes_cart_url;
    }

    const root =
      window.Shopify?.routes?.root || '/';

    return `${root}cart`;
  };

  const isCartAddRequest = (input, options = {}) => {
    try {
      const requestUrl =
        typeof input === 'string'
          ? input
          : input.url;

      const requestMethod = (
        options.method ||
        input.method ||
        'GET'
      ).toUpperCase();

      const url = new URL(
        requestUrl,
        window.location.origin
      );

      return (
        requestMethod === 'POST' &&
        /\/cart\/add(?:\.js)?$/.test(url.pathname)
      );
    } catch (error) {
      return false;
    }
  };

  const createToast = () => {
    let toast = document.querySelector(
      '[data-vlsur-global-cart-toast]'
    );

    if (toast) {
      return toast;
    }

    toast = document.createElement('div');

    toast.className =
      'vlsur-global-cart-toast';

    toast.dataset.vlsurGlobalCartToast = '';

    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');

    document.body.appendChild(toast);

    return toast;
  };

  const showToast = (responseData) => {
    /*
     * Evita duplicar la notificación que ya utiliza
     * la página individual del producto.
     */
    const productPageToast =
      document.querySelector(
        '.feedback.vlsur-cart-toast.visible'
      );

    if (productPageToast) {
      return;
    }

    const addedItem =
      Array.isArray(responseData.items)
        ? responseData.items[0]
        : responseData;

    if (!addedItem) {
      return;
    }

    const productTitle =
      addedItem.product_title ||
      addedItem.title ||
      'Producto';

    const variantTitle =
      addedItem.variant_title || '';

    const productImage =
      (
        addedItem.featured_image &&
        (
          addedItem.featured_image.url ||
          addedItem.featured_image.src
        )
      ) ||
      addedItem.image ||
      '';

    const productUrl =
      addedItem.url || getCartUrl();

    const toast = createToast();

    toast.replaceChildren();

    const content =
      document.createElement('div');

    content.className =
      'vlsur-global-cart-toast__content';

    if (productImage) {
      const imageLink =
        document.createElement('a');

      imageLink.className =
        'vlsur-global-cart-toast__image-link';

      imageLink.href = productUrl;

      const image =
        document.createElement('img');

      image.className =
        'vlsur-global-cart-toast__image';

      image.src = productImage;
      image.alt = productTitle;
      image.width = 64;
      image.height = 64;

      imageLink.appendChild(image);
      content.appendChild(imageLink);
    }

    const information =
      document.createElement('div');

    information.className =
      'vlsur-global-cart-toast__information';

    const confirmation =
      document.createElement('span');

    confirmation.className =
      'vlsur-global-cart-toast__confirmation';

    confirmation.textContent =
      '✓ Producto agregado al carrito';

    const title =
      document.createElement('a');

    title.className =
      'vlsur-global-cart-toast__title';

    title.href = productUrl;
    title.textContent = productTitle;

    information.appendChild(confirmation);
    information.appendChild(title);

    if (
      variantTitle &&
      variantTitle !== 'Default Title'
    ) {
      const variant =
        document.createElement('span');

      variant.className =
        'vlsur-global-cart-toast__variant';

      variant.textContent = variantTitle;

      information.appendChild(variant);
    }

    const viewCart =
      document.createElement('a');

    viewCart.className =
      'vlsur-global-cart-toast__view';

    viewCart.href = getCartUrl();
    viewCart.textContent = 'Ver carrito';

    information.appendChild(viewCart);
    content.appendChild(information);
    toast.appendChild(content);

    window.clearTimeout(hideTimer);

    toast.classList.remove('is-visible');

    window.requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    hideTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2000);
  };

  window.fetch = function (...argumentsList) {
    const input = argumentsList[0];
    const options = argumentsList[1] || {};

    const fetchPromise =
      originalFetch(...argumentsList);

    if (isCartAddRequest(input, options)) {
      fetchPromise
        .then((response) => {
          if (!response.ok) {
            return;
          }

          return response
            .clone()
            .json()
            .then((data) => {
              if (data.status) {
                return;
              }

              /*
               * Espera brevemente para comprobar si
               * la página del producto mostró su aviso.
               */
              window.setTimeout(() => {
                showToast(data);
              }, 50);
            });
        })
        .catch(() => {
          /*
           * El controlador original mostrará el error.
           */
        });
    }

    return fetchPromise;
  };
})();